// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-7 {
  font-family: Inter, sans-serif;
  overflow-wrap: break-word;
}
.section-7 p {
  color: white;
  font-size: 14px;
}
@media screen and (min-width: 1440px) {
  .section-7 p {
    font-size: 16px;
  }
}

.d-flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.flex-wrap {
  flex-wrap: wrap;
}

.child {
  width: 50%;
}
.child .logo-container {
  display: flex;
  flex-direction: column;
}
@media screen and (min-width: 834px) {
  .child .logo-container {
    flex-direction: row;
  }
}
.child .logo-container .logo {
  max-width: 65px;
  margin-bottom: 1rem;
}
@media screen and (min-width: 1440px) {
  .child .logo-container .logo {
    min-width: 81px;
  }
}
@media screen and (min-width: 834px) {
  .child .logo-container .logo {
    max-width: 58px;
    margin-right: 1rem;
    margin-bottom: 0;
  }
}
.child .logo-container .title-container {
  flex-direction: column;
}
@media screen and (min-width: 834px) {
  .child .logo-container .title-container {
    flex-direction: row;
  }
}
.child .logo-container .title {
  padding-right: 0.5rem;
  font-size: 24px;
  font-weight: 700;
  font-family: "Fontspring demo nekst", sans-serif;
  padding-top: 5px;
  margin-top: auto;
  margin-bottom: auto;
}
@media screen and (min-width: 1440px) {
  .child .logo-container .title {
    font-size: 40px;
  }
}
.child .price {
  font-size: 32px;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
@media screen and (min-width: 1440px) {
  .child .price {
    font-size: 40px;
  }
}
.child .tokens img {
  max-width: 42px;
  margin-right: 1rem;
  margin-bottom: 0.5rem;
}
@media screen and (min-width: 1440px) {
  .child .tokens img {
    min-width: 80px;
  }
}

.more-details {
  margin-top: 3rem;
}
@media screen and (min-width: 390px) {
  .more-details {
    width: 90%;
  }
}
.more-details.desktop {
  display: none;
}
@media screen and (min-width: 834px) {
  .more-details.desktop {
    display: block;
  }
}
@media screen and (min-width: 834px) {
  .more-details.mobile {
    display: none;
  }
}
.more-details .title {
  font-weight: 700;
  color: #03E287;
}`, "",{"version":3,"sources":["webpack://./src/styles/token.scss"],"names":[],"mappings":"AAAA;EAQE,8BAAA;EACA,yBAAA;AANF;AAFE;EACE,YAAA;EACA,eAAA;AAIJ;AAHI;EAHF;IAII,eAAA;EAMJ;AACF;;AADA;EACE,aAAA;AAIF;;AAFA;EACE,sBAAA;AAKF;;AAHA;EACE,eAAA;AAMF;;AAJA;EACE,UAAA;AAOF;AANE;EACE,aAAA;EACA,sBAAA;AAQJ;AAPI;EAHF;IAII,mBAAA;EAUJ;AACF;AATI;EACE,eAAA;EACA,mBAAA;AAWN;AAVM;EAHF;IAII,eAAA;EAaN;AACF;AAZM;EANF;IAOI,eAAA;IACA,kBAAA;IACA,gBAAA;EAeN;AACF;AAbI;EACE,sBAAA;AAeN;AAdM;EAFF;IAGI,mBAAA;EAiBN;AACF;AAfI;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,gDAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAiBN;AAhBM;EARF;IASI,eAAA;EAmBN;AACF;AAhBE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAkBJ;AAjBI;EAJF;IAKI,eAAA;EAoBJ;AACF;AAjBI;EACE,eAAA;EACA,kBAAA;EACA,qBAAA;AAmBN;AAlBM;EAJF;IAKI,eAAA;EAqBN;AACF;;AAhBA;EAIE,gBAAA;AAgBF;AAnBE;EADF;IAEI,UAAA;EAsBF;AACF;AApBE;EACE,aAAA;AAsBJ;AArBI;EAFF;IAGI,cAAA;EAwBJ;AACF;AArBI;EADF;IAEI,aAAA;EAwBJ;AACF;AArBE;EACE,gBAAA;EACA,cAAA;AAuBJ","sourcesContent":[".section-7{\r\n  p{\r\n    color: white;\r\n    font-size: 14px;\r\n    @media screen and (min-width: 1440px){\r\n      font-size: 16px;\r\n    }\r\n  }\r\n  font-family: Inter, sans-serif;\r\n  overflow-wrap: break-word;\r\n}\r\n.d-flex{\r\n  display: flex;\r\n}\r\n.flex-col{\r\n  flex-direction: column;\r\n}\r\n.flex-wrap{\r\n  flex-wrap: wrap;\r\n}\r\n.child{\r\n  width: 50%;\r\n  .logo-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    @media screen and (min-width: 834px){\r\n      flex-direction: row;\r\n    }\r\n    .logo{\r\n      max-width: 65px;\r\n      margin-bottom: 1rem;\r\n      @media screen and (min-width: 1440px){\r\n        min-width: 81px;\r\n      }\r\n      @media screen and (min-width: 834px){\r\n        max-width: 58px;\r\n        margin-right: 1rem;\r\n        margin-bottom: 0;\r\n      }\r\n    }\r\n    .title-container{\r\n      flex-direction: column;\r\n      @media screen and (min-width: 834px){\r\n        flex-direction: row;\r\n      }\r\n    }\r\n    .title{\r\n      padding-right:0.5rem;\r\n      font-size: 24px;\r\n      font-weight: 700;\r\n      font-family: 'Fontspring demo nekst', sans-serif;\r\n      padding-top: 5px;\r\n      margin-top: auto;\r\n      margin-bottom: auto;\r\n      @media screen and (min-width: 1440px){\r\n        font-size: 40px;\r\n      }\r\n    }\r\n  }\r\n  .price{\r\n    font-size: 32px;\r\n    margin-top: 1rem;\r\n    margin-bottom: 1rem;\r\n    @media screen and (min-width: 1440px){\r\n      font-size: 40px;\r\n    }\r\n  }\r\n  .tokens{\r\n    img{\r\n      max-width: 42px;\r\n      margin-right: 1rem;\r\n      margin-bottom: 0.5rem;\r\n      @media screen and (min-width: 1440px){\r\n        min-width: 80px;\r\n      }\r\n    }\r\n  }\r\n  \r\n}\r\n.more-details{\r\n  @media screen and (min-width: 390px){\r\n    width: 90%;\r\n  }\r\n  margin-top: 3rem;\r\n  &.desktop{\r\n    display: none;\r\n    @media screen and (min-width: 834px){\r\n      display: block;\r\n    }\r\n  }\r\n  &.mobile{\r\n    @media screen and (min-width: 834px){\r\n      display: none;\r\n    }\r\n    \r\n  }\r\n  .title{\r\n    font-weight: 700;\r\n    color: #03E287;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
